<script lang="ts">
import { defineComponent } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { ElMessage } from 'element-plus'

import useRouter from '@/hooks/useRouter'

export default defineComponent({
  async setup() {
    const userStore = useUserStore()
    const { router } = useRouter()
    const link = await userStore.GetTelegramLink()

    window.open(link, '_blank')
    router.push(`/dashboard`)

    ElMessage.error({
      message: `In case you haven't been redirected to telegram, <b><a href="${link}" target="_blank">please click here</a></b>.`,
      showClose: true,
      duration: 15000,
      dangerouslyUseHTMLString: true
    })
  }
})
</script>
